import { render, staticRenderFns } from "./MilestoneTasks.vue?vue&type=template&id=800ecc7c&scoped=true&"
import script from "./MilestoneTasks.vue?vue&type=script&lang=js&"
export * from "./MilestoneTasks.vue?vue&type=script&lang=js&"
import style0 from "./MilestoneTasks.vue?vue&type=style&index=0&id=800ecc7c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "800ecc7c",
  null
  
)

export default component.exports